import {
  AUDIO_VOL, SOUND_VOL, LOAD_CONFIG, SAVE_CONFIG, LOG_IN, SHOW_SPINNER, HIDE_SPINNER,
  SHOW_NOTIFICATION, COURSES_LOADED
} from '../types';
import api from '../../api';
import defaultConfig from '../../config/defaultConfig.json';
import sessionErrHandler from './sessionErrHandler';

export const loadConfig = () => async dispatch => {
  dispatch({ type: SHOW_SPINNER, payload: 'Pobieram kofigurację' });
  let response;
  try {
    response = await api.get('/user/setting/config.json', { withCredentials: true });

    if (response.status === 200) {
      let config = parseConfig(response.data)
      if (Object.keys(config).length === 0) config = defaultConfig;
      dispatch({ type: LOAD_CONFIG, config });
      dispatch({ type: LOG_IN });
      dispatch({ type: AUDIO_VOL, vol: config.main.audioVolume });
      dispatch({ type: SOUND_VOL, vol: config.main.soundsVolume });
    } else {
      dispatch({
        type: SHOW_NOTIFICATION,
        payload: { message: 'Błąd podczas pobierania konfiguracji', type: 'error' }
      });
    }
  } catch (e) {
    sessionErrHandler(e, 'Błąd podczas pobierania konfiguracji', dispatch);
  }
  dispatch({ type: HIDE_SPINNER });
}

export const saveConfig = (config) => async dispatch => {
  if (Object.keys(config).length === 0) config = defaultConfig;

  const options = {
    method: 'post',
    data: { code: 'config.json', value: JSON.stringify(config) },
    url: '/user/setting',
    withCredentials: true
  }

  let response;
  try {
    response = await api(options);
    if (response.status === 200) {
      dispatch({ type: SAVE_CONFIG, config });
      dispatch({ type: AUDIO_VOL, vol: config.main.audioVolume });
      dispatch({ type: SOUND_VOL, vol: config.main.soundsVolume });
    } else {
      dispatch({
        type: SHOW_NOTIFICATION,
        payload: { message: 'Błąd: konfiguracja nie została zapisana', type: 'error' }
      });
    }
  } catch (e) {
    sessionErrHandler(e, 'Błąd: konfiguracja nie została zapisana', dispatch);
  }
}

export const savePlayerConfig = (playerConfig) => async (dispatch, getState) => {
  const state = getState();
  dispatch(saveConfig({ ...state.config, player: playerConfig }));
}

export const saveMainConfig = (mainConfig) => async (dispatch, getState) => {
  const state = getState();
  dispatch(saveConfig({ ...state.config, main: mainConfig }));
}

export const setCoursesLoaded = () => (dispatch) => {
  dispatch({ type: COURSES_LOADED, payload: true });
}

function parseConfig(config) {
  let newConfig = {};
  try {
    newConfig = JSON.parse(config.value);
  } catch (e) { }
  return newConfig;
}

function getWindowSize() {
  var win = window,
    doc = document,
    docElem = doc.documentElement,
    body = doc.getElementsByTagName('body')[0],
    x = win.innerWidth || docElem.clientWidth || body.clientWidth,
    y = win.innerHeight || docElem.clientHeight || body.clientHeight;
  return Math.min(x, y);
}

const screenSize = getWindowSize();

const defaultLocalSettings = {
  saveBandwidth: screenSize < 500 ? true : false,
};

export function getLocalSettings(setting) {
  const savedSettings = localStorage.getItem('sa-settings');
  let settings;
  if (savedSettings) {
    const parsedSettings = JSON.parse(savedSettings);
    settings = { ...defaultLocalSettings, ...parsedSettings };
  } else {
    const newSettings = { ...defaultLocalSettings };
    localStorage.setItem('sa-settings', JSON.stringify(newSettings));
    settings = newSettings;
  }
  if (setting) return settings[setting];
  return settings
}

export function saveLocalSettings(settings) {
  const currentSettings = getLocalSettings();
  const newSettings = { ...currentSettings, ...settings };
  localStorage.setItem('sa-settings', JSON.stringify(newSettings));
}
